import { render, staticRenderFns } from "./ResourceCollectionItem.vue?vue&type=template&id=0b686617"
import script from "./ResourceCollectionItem.vue?vue&type=script&lang=js"
export * from "./ResourceCollectionItem.vue?vue&type=script&lang=js"
import style0 from "./ResourceCollectionItem.vue?vue&type=style&index=0&id=0b686617&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports